import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class NotesApi {
    constructor(private axios: AxiosInstance) {
    }

    collectNotes = async (): Promise<Array<NoteType>> => {
        const {data}: { data: Array<NoteType> } = await this.axios
            .withAuthentication()
            .get('/v1/collect-notes');

        return data;
    };

    addNote = async (text: string) => {
        const {data} = await this.axios
            .withAuthentication()
            .post('/v1/add-note', {
                text: text,
            });

        return data;
    };

    deleteNote = async (id: string) => {
        await this.axios.withAuthentication().post('/v1/delete-note', {
            id: id,
        });
    };
}

export type NoteType = { id: string; text: string };

decorate(injectable(), NotesApi);
decorate(inject(AxiosInstance), NotesApi, 0);

export {NotesApi};
